import { render, staticRenderFns } from "./PricingPopup.vue?vue&type=template&id=58822b3d"
import script from "./PricingPopup.vue?vue&type=script&lang=js"
export * from "./PricingPopup.vue?vue&type=script&lang=js"
import style0 from "./PricingPopup.vue?vue&type=style&index=0&id=58822b3d&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58822b3d')) {
      api.createRecord('58822b3d', component.options)
    } else {
      api.reload('58822b3d', component.options)
    }
    module.hot.accept("./PricingPopup.vue?vue&type=template&id=58822b3d", function () {
      api.rerender('58822b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/PricingPopup.vue"
export default component.exports